// Classes.
import {DataContainer, Metadata} from './data-container';

// Interfaces.
import {LocatorInterface} from '../interfaces/locator.interface'


export class DataContainerErroneous extends DataContainer<any> {

  public constructor(locator: LocatorInterface) {
    super(locator, null, new Metadata(0), 0);
  }

  public get expired(): boolean {
    return true;
  }

  public get erroneous(): boolean {
    return true;
  }
}